import loadable from '@loadable/component';

export const OrgDashboardCreateEventPageContainerLoadable = loadable(
  () => import('./OrgDashboardCreateEventPageContainer'),
  {
    resolveComponent: (module) => module.OrgDashboardCreateEventPageContainer,
    ssr: false,
  },
);
